import { render, staticRenderFns } from "./PagesOneTwoTheeWidget.vue?vue&type=template&id=36e02332&"
import script from "./PagesOneTwoTheeWidget.vue?vue&type=script&lang=js&"
export * from "./PagesOneTwoTheeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports